export const GENDER_NONE = 0;
export const GENDER_MALE = 1;
export const GENDER_FEMALE = 2;

export const COURSE_TYPE_TRAINER = 0;
export const COURSE_TYPE_COACH = 1;
export const COURSE_TYPE_PRIVATE = 2;
export const COURSE_TYPE_TRAINER_SELF = 3;

export const SHARE_TYPE_TRAINER = 'trainer';
export const SHARE_TYPE_INVITE = 'invite';
export const SHARE_TYPE_COURSE = 'course';



// WEBPACK FOOTER //
// ./src/constants/types.js